import React, { useEffect, useState } from 'react';
import { CustomTable } from './CustomTable';
import { Dialog, DialogContent, DialogTitle, Divider, Grid } from '@material-ui/core';
import { ReportsVService, ServiceStatusEnum } from '../../services/V2/gozer';
import { handleChange } from './Functions';

export const AccountSearch = ({ isOpen, handleClose, operatorId, districts, listingModel, setListingModel, setBillingAccountId, forceDistrictSelection }) => {
	const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({
        operatorId: operatorId
    });

    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);

    useEffect(() => {
        if (forceDistrictSelection) {
            setFormData({
                ...formData,
                districtIds: [districts[0].id]
            })
        }
    }, [forceDistrictSelection])// eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = () => {
        setRefresh(true)
    }

    const handleReset = () => {
        setFormData({
            operatorId: operatorId
        })
    }

    const handleDistrictChange = (event, model, setModel) => {
        let value = event.target.value !== "" ? [event.target.value] : undefined;

        setModel({
            ...model,
            districtIds: value
        })
    }

    const chooseAccount = (rowData) => {
        setListingModel({
			...listingModel,
			accountNumber: rowData.accountNumber,
            districts: [rowData.districtId]
		});

        if (setBillingAccountId) {
            setBillingAccountId(rowData.billingAccountId)
        }

        handleClose()
    }

    const handleAccountChange = (event, model, setModel) => {
        let name = event.target.name;
        let value = event.target.value !== "" ? event.target.value : undefined;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setModel({
            ...model,
            [name]: value?.replace(/\D/g,'') ?? ""
        })
    }

    return (
        <React.Fragment>
            <Dialog fullScreen onClose={handleClose} open={isOpen} style={{ margin: "20px" }}>
                <DialogTitle style={{ textAlign: "left", padding: "5px 0px 5px 10px" }}>
                    Customer Lookup
                </DialogTitle>
                <Divider />
                <DialogContent style={{ padding: "8px 0px 0px 0px" }}>
                    <Grid container>
                        <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <div style={{ display: 'flex' }}>
                                <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                    <b>Name</b><span>&nbsp;:&nbsp;</span>
                                    <input
                                        className='uvp-input'
                                        style={{ width: "250px" }}
                                        onChange={e => handleChange(e, formData, setFormData)}
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData?.name || ""} />
                                </label>
                            </div>
                            <div style={{ display: 'flex' }}>
                            <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                <b>Service Address</b><span>&nbsp;:&nbsp;</span>
                                <input
                                    className='uvp-input'
                                    style={{ width: "250px" }}
                                    onChange={e => handleChange(e, formData, setFormData)}
                                    type="text"
                                    id="serviceAddress"
                                    name="serviceAddress"
                                    value={formData.serviceAddress || ""} />
                            </label>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <label className='uvp-label' style={{ marginTop: '2px', marginRight: "10px" }}>
                                <b>Account</b><span>&nbsp;:&nbsp;</span>
                                <input
                                    className='uvp-input'
                                    style={{ width: "250px" }}
                                    onChange={e => handleAccountChange(e, formData, setFormData)}
                                    type="text"
                                    id="accountNumber"
                                    name="accountNumber"
                                    value={formData.accountNumber || ""} />
                            </label>
                        </div>
                        </Grid>
                        <Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <label className='uvp-label' style={{ marginTop: '2px' }}>
                                <b>District</b><span>&nbsp;:&nbsp;</span>
                                <select
                                    className='uvp-select'
                                    onChange={e => handleDistrictChange(e, formData, setFormData)}
                                    style={{ width: "250px", textAlign: 'left' }}
                                    name="districtId"
                                    id="districtId"
                                    value={formData.districtIds || ""}
                                    disabled={forceDistrictSelection}
                                >
                                    <option value=""></option>
                                    {districts
                                        .sort()
                                        .map(x => (
                                        <option key={x.id} value={x.id}>
                                            {x.name}
                                        </option>
                                        ))
                                    }
                                </select>
                            </label>
                            <label className='uvp-label' style={{ marginTop: '2px' }}>
                                <b>Sort</b><span>&nbsp;:&nbsp;</span>
                                <select
                                    className='uvp-select'
                                    onChange={e => handleChange(e, formData, setFormData)}
                                    style={{ width: "250px", textAlign: 'left' }}
                                    name="orderBy"
                                    id="orderBy"
                                    value={formData.orderBy || ""}
                                >
                                    <option value=""></option>
                                    <option value="accountNumber">
                                        Account
                                    </option>
                                    <option value="fullName">
                                        Name
                                    </option>
                                    <option value="serviceAddress">
                                        Service Address
                                    </option>
                                </select>
                            </label>
                            <label className='uvp-label' style={{ marginTop: '2px' }}>
                                <b>Status</b><span>&nbsp;:&nbsp;</span>
                                <select
                                        className='uvp-select'
                                        onChange={e => handleChange(e, formData, setFormData)}
                                        style={{ width: "250px", textAlign: 'left' }}
                                        name="serviceStatus"
                                        id="serviceStatus"
                                        value={formData.serviceStatus || ""}
                                    >
                                        <option value=""></option>
                                        {Object.keys(ServiceStatusEnum)
                                            .sort()
                                            .map((r) => (
                                            <option key={r} value={ServiceStatusEnum[r]}>
                                                {ServiceStatusEnum[r]}
                                            </option>
                                            ))
                                        }
                                    </select>
                            </label>
                        </Grid>
                        <Grid item xs={4} style={{ alignSelf: "flex-end", textAlign: "right" }}>
                            <button
                                className='uvp-button green-button'
                                type="button"
                                onClick={handleSubmit}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                }}
                            >
                                Find
                            </button>
                            <button
                                className='uvp-button gray-button'
                                type="button"
                                onClick={handleReset}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                }}
                            >
                                Reset
                            </button>
                            <button
                                className='uvp-button gray-button'
                                type="button"
                                onClick={handleClose}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                }}
                            >
                                Close
                            </button>
                        </Grid>
                    </Grid>
                    <CustomTable
                        columns={[
                            { title: 'Customer', field: 'accountNumber', render: rowData =>
                                <>
                                    <button
                                        className='clickable'
                                        style={{ color: "#4caf50", background: "transparent", border: "none" }}
                                        onClick={() => chooseAccount(rowData)}>
                                        <u>{rowData.accountNumber}</u>
                                    </button>
                                </>
                            },
                            { title: 'Name', field: 'fullName' },
                            { title: 'Service Address', field: 'serviceAddress' },
                            { title: 'Mail Address', field: 'billingAddress' },
                            { title: 'Status', field: 'serviceStatus' }
                        ]}
                        pageSize={10}
                        enablePaging={true}
                        actions={[]}
                        hiddenColumns={[]}
                        setHiddenColumns={null}
                        hiddenColumnsDisabled={true}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        dataEndpoint={(query) => {
                                return new Promise((resolve, reject) => {
                                    const sendForm = { ...formData };
                                    ReportsVService.reportsVPaymentListingAccountSearch(sendForm)
                                    .then((x:any) => {
                                        resolve({
                                            items: x.sort((a,b) => (a?.[formData.orderBy] ?? "").localeCompare(b?.[formData.orderBy] ?? "") ?? "") ?? [],
                                            numberOfItems: x.length
                                        })
                                    })
                                    .catch(x => reject(x))
                                })
                            }
                        }
                        dataSet={null}
                        title={""}
                        districtId={null}
                        addedQuery={null}
                        tableHeight={"336px"}
                        enableSearch={false}
                        searchPlaceholder={null} />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}